import BpkGraphicPromo, {
  TEXT_ALIGN,
} from '@skyscanner-internal/backpack-web/bpk-component-graphic-promotion';
import { translate } from '@web-platform/shared-universal-translations';
import { redirect } from 'saddlebag-browser';

import STYLES from './EventsGraphicPromo.module.scss';

const EVENTS_IMAGE_URL =
  'https://content.skyscnr.com/m/2096c684994a8739/original/anthony-delanoix-hzgs56Ze49s-unsplash.jpg';

export const EventsGraphicPromo = () => (
  <BpkGraphicPromo
    contentId="events-graphic-promo"
    headline={translate('events_gp_header')}
    subheading={translate('events_gp_sub')}
    buttonText={translate('events_gp_cta')}
    invertVertically
    textAlign={TEXT_ALIGN.start}
    className={STYLES.eventsGraphicPromo}
    style={{
      '--background-image-mobile': `url('${EVENTS_IMAGE_URL}')`,
      '--background-image-desktop': `url('${EVENTS_IMAGE_URL}')`,
    }}
    onClick={() => redirect('/explore-events/?eventsSource=homepage_banner')}
  />
);
